export default "/_next/static/sounds/scott_where_are_you-afebc8e8f999dcdf4f268ab64ae5100a.mp3";